var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthcare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    stroke: "#2C67F1",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1 11.9151L12.7 14.5189L18.55 8.66038M13.9911 4.28059C11.3919 1.23754 7.05767 0.418968 3.8011 3.20549C0.544537 5.99201 0.0860581 10.6509 2.64346 13.9466C4.57512 16.4358 10.0627 21.4331 12.6324 23.7296C13.1048 24.1517 13.341 24.3628 13.6176 24.4459C13.8577 24.518 14.1245 24.518 14.3646 24.4459C14.6412 24.3628 14.8774 24.1517 15.3498 23.7296C17.9195 21.4331 23.4071 16.4358 25.3387 13.9466C27.8961 10.6509 27.4936 5.9627 24.1811 3.20549C20.8685 0.448279 16.5903 1.23754 13.9911 4.28059Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthcare);
export default __webpack_public_path__ + "static/media/healthcare.a5abbcd3dd6f8ea045e1e3ab4ef3b6e0.svg";
export { ForwardRef as ReactComponent };